import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {jobProfilesEdit_template} from "../components/templates/jobProfilesEdit_template";
import {header} from "./header";
import * as classicEditor from "@ckeditor/ckeditor5-build-classic";

declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;
CKEDITOR.timestamp = '1.2.0';

let longDescriptionEditor;
let additionalTextEditor;
let referentialWorkInstructionsEditor;
let writtenSampleInstructionsEditor;
let imageSampleInstructionsEditor;
let questionTextEditor;


export class job_profiles_edit extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: jobProfilesEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName() {
        return "job_profiles_edit";
    }

    buildContent(): Array<Element> {

        // create the jobs form
        this.editForm = new jobProfilesEdit_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Job Profile Form");

        return [this.editForm.build()];
    }

    fillPage(): void {

        this.setUpCkEditorInstances();
        this.getFormData();
    }

    protected saveJob() {

        this.save();
    }

    public cancel(){

        this.redirectToListPage();
    }

    public redirectToListPage() {

        this.releaseLock();

        let previousUrl = this.loadPreviousPage(window.location.href);
        if(previousUrl){
            page.redirect(previousUrl);
        }else{
            page('/job/profiles');
        }
    }

    public filterMultipleSelectorOnChange() {

    }

    // obtain the dynamic data required to fill the formulary
    protected getFormData() {

        this.loadingIn(this.editForm.builtTemplate);

        let id: number;

        if ((id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.editForm.getTemplateViewModel().id(id);
        }

        let usrReq_url: string = '/api/job/profiles/get/' + id + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({lockItem: true})]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }

    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                obj.setupForm(responseParsed.data);
                obj.loadingOut(obj.editForm.builtTemplate);
            })
        }
    }

    public setupForm(data){

        this.editForm.setRoles(data.roles);
        this.editForm.setNetworkCategories(data.networkCategories);
        this.editForm.setConfigOptions(data.configOptions);

        let brands = data.brands;
        brands.unshift({'id': 0, 'name':'Select'})
        this.editForm.setBrands(brands);

        if(data.jobProfile.id){
            this.setUpProfile(data.jobProfile);
            this.setUpCkEditorsData(data.jobProfile);
        }

        //for question config options change the text for default option
        let configOptions =  data.configOptions;
        configOptions[0].name = 'Select An Option';
        this.editForm.setQuestionConfigOptions(configOptions)
    }

    public setUpProfile(profile){

        let vnApp = this.getVnAppZone().app;
        this.editForm.setLoggedUserId(vnApp.loggedUser.user.id);
        this.editForm.setId(profile.id);
        this.editForm.setName(profile.name);
        this.editForm.setAvailability(profile.availability);
        this.editForm.setLocation(profile.location);
        this.editForm.setExperience(profile.experience);
        this.editForm.setLongDescription(profile.longDescription);
        this.editForm.setAdditionalText(profile.additionalText);
        this.editForm.setIdResume(profile.resume.id);
        this.editForm.setIdCoverLetter(profile.coverLetter.id);
        this.editForm.setIdReferentialWork(profile.referentialWork.id);
        this.editForm.setIdWrittenSample(profile.writtenSample.id);
        this.editForm.setIdImageSample(profile.imageSample.id);
        this.editForm.setQuestions(profile.questions);
        this.editForm.setPosition(profile.position);
        this.editForm.setImageUrl(profile.imageUrl);
        this.editForm.setIsActive(profile.isActive);
        this.editForm.setLastDateDisabled(profile.lastDateEnabled);
        this.editForm.setLastDateEnabled(profile.lastDateDisabled);
        this.editForm.setIdNetworkCategory(profile.networkCategory.id)
        this.editForm.setIdRole(profile.role.id)
        this.editForm.setIdBrand(profile.brand.id)
        this.editForm.setGeos(profile.geos);
    }

    public setUpCkEditorsData(jobProfile){

        if(jobProfile.longDescription){
            longDescriptionEditor.setData(jobProfile.longDescription);
        }
        if(jobProfile.additionalText){
            additionalTextEditor.setData(jobProfile.additionalText);
        }
        if(jobProfile.referentialWorkInstructions){
            referentialWorkInstructionsEditor.setData(jobProfile.referentialWorkInstructions);
        }
        if(jobProfile.writtenSampleInstructions){
            writtenSampleInstructionsEditor.setData(jobProfile.writtenSampleInstructions);
        }
        if(jobProfile.imageSampleInstructions){
            imageSampleInstructionsEditor.setData(jobProfile.imageSampleInstructions);
        }
    }

    public getSavePostData(){

        return {
            id: this.editForm.getTemplateViewModel().id(),
            name: this.editForm.getTemplateViewModel().name(),
            idBrand: this.editForm.getTemplateViewModel().idBrand(),
            location: this.editForm.getTemplateViewModel().location(),
            availability: this.editForm.getTemplateViewModel().availability(),
            experience: this.editForm.getTemplateViewModel().experience(),
            longDescription: longDescriptionEditor.getData(),
            additionalText: additionalTextEditor.getData(),
            idRole: this.editForm.getTemplateViewModel().idRole(),
            idNetworkCategory: this.editForm.getTemplateViewModel().idNetworkCategory(),
            geos: this.editForm.getTemplateViewModel().geos(),
            idResume: this.editForm.getTemplateViewModel().idResume(),
            idCoverLetter: this.editForm.getTemplateViewModel().idCoverLetter(),
            idReferentialWork: this.editForm.getTemplateViewModel().idReferentialWork(),
            referentialWorkInstructions: referentialWorkInstructionsEditor.getData(),
            idWrittenSample: this.editForm.getTemplateViewModel().idWrittenSample(),
            writtenSampleInstructions: writtenSampleInstructionsEditor.getData(),
            idImageSample: this.editForm.getTemplateViewModel().idImageSample(),
            imageSampleInstructions: imageSampleInstructionsEditor.getData(),
            idQuestion: this.editForm.getTemplateViewModel().idQuestion(),
            questions: this.editForm.getTemplateViewModel().questions(),
            position: this.editForm.getTemplateViewModel().position(),
            imageUrl: this.editForm.getTemplateViewModel().imageUrl(),
            isActive: this.editForm.getTemplateViewModel().isActive(),
            lastDateEnabled: this.editForm.getTemplateViewModel().lastDateEnabled(),
            lastDateDisabled: this.editForm.getTemplateViewModel().lastDateDisabled(),
        };
    }

    protected save() {

        this.loadingIn(this.editForm.builtTemplate);

        let formReq_url: string = '/api/job/profiles/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.getSavePostData();
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.releaseLock();

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Job Profile saved successfully !");

                    obj.redirectToListPage();
                });
                obj.loadingOut(obj.editForm.builtTemplate);

            }
        });
        XHRHdl.execute();
    }

    protected releaseLock() {

        // request a lock release
        let usrReq_url: string = '/api/job/profiles/release/' + this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }


    public getSuggestions(keyword, idElement) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword},  idElement: idElement};
        let usrReq_url: string = '/api/search/geo/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){
                let response = JSON.parse(req.request.response);
                obj.editForm.geosFilter.setOptions(response.data.geos);
            });
        }
    }

    public getImageData(keyword = null) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.editForm.imagePicker.showLoading();

        const idBrand = this.editForm.getTemplateViewModel().idBrand();
        const formReq_url: string = idBrand ? '/api/brand/' + idBrand + '/images/get/' : '/api/images/get/';
        const formReq_params: Array<Array<string>> = [];

        formReq_params.push(["data", ko.toJSON(this.editForm.imagePicker.getViewModelForRequest())]);

        this.XHRHdl = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.GET;
        this.XHRHdl.onReadyStateFunction = this.onGetImageDataReturn;
        this.XHRHdl.execute();
    }

    public onGetImageDataReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateImagePickerForm(responseParsed);
                obj.editForm.imagePicker.hideLoading();
            });
        };
    }

    public updateImagePickerForm(responseParsed) {

        let selectedImages = this.editForm.imagePicker.getSelectedImages();

        if (responseParsed.paginatedImages && responseParsed.paginatedImages.data) {
            for (let image of responseParsed.paginatedImages.data) {
                image.selected = false;
                let imageSelected = selectedImages.find(i => i.id == image.id);
                if (imageSelected) {
                    image.selected = true;
                }
                image.fileSize = this.bytesToSize(image.fileSize);
            }
            this.editForm.imagePicker.setImagesPagination(responseParsed.paginatedImages);
            this.editForm.imagePicker.setImageResults(responseParsed.paginatedImages.data);
        }
    }

    protected bytesToSize(bytes) {
        const sizes = ['KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return 'n/a';
        const i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))));
        if (i == 0) return bytes + ' ' + sizes[i];
        return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
    }

    public insertImage(image, target, extra_option) {

        let editor = null;
        if (target === 'longDescription') {
            editor = longDescriptionEditor;
        } else if (target === 'additionalText') {
            editor = additionalTextEditor;
        }

        if (!editor || !image || !image.url) {
            return;
        }

        this.insertImageIntoCkEditor(editor, image);
        this.editForm.imagePicker.hide();
        this.editForm.setImagePickerTarget(null);
    }

    protected insertImageIntoCkEditor(editor, image) {

        const safeAttr = (val) => String(val == null ? '' : val).replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        const src = safeAttr(image.url);
        const alt = safeAttr(image.altText || '');
        const html = `<figure class="image"><img src="${src}" alt="${alt}"></figure>`;

        editor.model.change((writer) => {
            try {
                const viewFragment  = editor.data.processor.toView(html);
                const modelFragment = editor.data.toModel(viewFragment);
                editor.model.insertContent(modelFragment, editor.model.document.selection);
            } catch (err) {
                console.error('Failed to insert image into editor:', err);
            }
        });
    }

    /**
     * Append a custom "Insert image" button into a CKEditor 5 toolbar.
     * The classic build is a monolithic bundle without exposed ButtonView, so we
     * inject a DOM button styled like a native CKE5 toolbar button instead.
     */
    protected addImagePickerToolbarButton(editor, target: string) {

        if (!editor || !editor.ui || !editor.ui.view || !editor.ui.view.toolbar || !editor.ui.view.toolbar.element) {
            return;
        }

        const toolbarElement: HTMLElement = editor.ui.view.toolbar.element;

        if (toolbarElement.querySelector(`button[data-image-picker-target="${target}"]`)) {
            return;
        }

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ck ck-button ck-off';
        button.tabIndex = -1;
        button.title = 'Insert image';
        button.setAttribute('aria-label', 'Insert image');
        button.setAttribute('data-image-picker-target', target);
        button.innerHTML = `
            <svg class="ck ck-icon ck-button__icon" viewBox="0 0 20 20">
                <path d="M2 3v14h16V3H2zm14 12H4V5h12v10z"></path>
                <path d="M5.5 11l2-2.5 1.5 2 2.5-3.5L15 14H5l.5-3z"></path>
                <circle cx="6.5" cy="7" r="1.2"></circle>
            </svg>
            <span class="ck ck-button__label">Image</span>
        `;
        button.addEventListener('click', (e) => {
            e.preventDefault();
            this.editForm.showImagePicker('single-select', target);
        });

        toolbarElement.appendChild(button);
    }

    protected onAutocompleteInputClick(idElement) {

    }

    protected onAutocompleteOptionChange(idElement) {

        if (idElement == "filterAutocompleteGEO_template"){
            let geos = this.editForm.getTemplateViewModel().geos();
            let chosenGeo = this.editForm.geosFilter.getTemplateViewModel().optionObj();
            let duplicateGeo = false;

            for (let geo of geos) {
                if (geo.id === chosenGeo.id) {
                    duplicateGeo = true;
                    break;
                }
            }

            if (!duplicateGeo) {
                geos.push(chosenGeo);
                this.editForm.getTemplateViewModel().geos(geos);
            }
        }
    }

    protected getQuestionEditorData(){

        return questionTextEditor.getData();
    }

    protected setQuestionEditorData(data){

        questionTextEditor.setData(data);
        return;
    }

    protected setUpCkEditorInstances(){

        //longDescription
        classicEditor.create( document.querySelector('#longDescription'),this.getCkEditorConfigOption())
        .then(newEditor => {
            longDescriptionEditor =  newEditor;
            this.addImagePickerToolbarButton(newEditor, 'longDescription');
        })
        .catch(error => {
            console.error(error);
        });

        //additionalText
        classicEditor.create( document.querySelector('#additionalText'), this.getCkEditorConfigOption())
        .then(newEditor => {
            additionalTextEditor =  newEditor;
            this.addImagePickerToolbarButton(newEditor, 'additionalText');
        })
        .catch(error => {
            console.error(error);
        });

        //referentialWorkInstructions
        classicEditor.create( document.querySelector('#referentialWorkInstructions'),this.getCkEditorConfigOption())
        .then(newEditor => {
            referentialWorkInstructionsEditor =  newEditor;
        })
        .catch(error => {
            console.error(error);
        });

        //writtenSampleInstructions
        classicEditor.create( document.querySelector("#writtenSampleInstructions"),this.getCkEditorConfigOption())
        .then(newEditor => {
            writtenSampleInstructionsEditor =  newEditor;
        })
        .catch(error => {
            console.error(error);
        });

        //imageSampleInstructions
        classicEditor.create( document.querySelector('#imageSampleInstructions'), this.getCkEditorConfigOption())
        .then(newEditor => {
            imageSampleInstructionsEditor =  newEditor;
        })
        .catch(error => {
            console.error(error);
        });

        // question
        classicEditor.create( document.querySelector('#question'),this.getCkEditorConfigOption())
        .then(newEditor => {
            questionTextEditor =  newEditor;

            //Listener to track data changes on the editor
            newEditor.model.document.on('change:data', () => {
                const questionText = newEditor.getData()
                this.editForm.getTemplateViewModel().questionEditorTextIsEmpty(questionText.trim() === "")
            });
        })
        .catch(error => {
            console.error(error);
        });


    }

    protected getCkEditorConfigOption(){

        return {
            toolbar: [ 'heading', 'bold', '|', 'italic', 'link', 'bulletedList', 'numberedList', 'indent' ],
            removePlugins: [ 'ImageToolbar', 'ImageStyle', 'ImageCaption' ],
            link: {
                defaultProtocol: 'https://'
            },
            heading : {
                options: [
                    { model : 'paragraph', title: 'Paragraph', class : 'ck-heading_paragraph' },
                    { model : 'heading1', view : 'h1', title : 'Heading 1', class : 'ck-heading_heading1' },
                    { model : 'heading2', view : 'h2', title : 'Heading 2', class : 'ck-heading_heading2' },
                    { model : 'heading3', view : 'h3', title : 'Heading 3', class : 'ck-heading_heading3' }
                ]
            },
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/job_profiles_edit.ts